<template>
  <fotos />
</template>

<script>
import Fotos from '../components/OpbouwPlechtigheid/Fotos.vue'

export default {
  name: 'FotosView',
  components: {
    Fotos
  }
}
</script>
